// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2K8VK","name":"Header_name__tiLRg","birthday":"Header_birthday__2Nbnd","skeleton":"Header_skeleton__IP8jr"};